import React from 'react'
import loadable from '@loadable/component'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

// Components
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {configureRoutes} from '@salesforce/retail-react-app/app/utils/routes-utils'
import {DEFAULT_EDITORIAL_PATH_PREFIX} from './utils/data/constants'
// import {routes as _routes} from '@salesforce/retail-react-app/app/routes'

const fallback = <Skeleton height="75vh" width="100%" />

const Home = loadable(() => import('./pages/home'), {fallback})
const Editorial = loadable(() => import('./pages/editorial'), {fallback})
const ProductList = loadable(() => import('./pages/product-list'), {fallback})
const ProductDetails = loadable(() => import('./pages/product-details'), {fallback})
const Wishlist = loadable(() => import('./pages/wishlist'), {fallback})
const PageDesignerTest = loadable(() => import('./pages/page-designer-test'), {fallback})

const routes = [
    {
        path: '/',
        component: Home,
        exact: true,
    },
    {
        path: '/home-as-feeling',
        component: PageDesignerTest,
        exact: true,
    },
    {
        path: '/test-double-same-plp',
        component: PageDesignerTest,
        exact: true,
    },
    {
        path: '/wishlist',
        component: Wishlist,
        exact: true,
    },
    {
        path: '/search',
        component: ProductList,
        exact: true,
    },
    {
        path: `/${DEFAULT_EDITORIAL_PATH_PREFIX}/:cid`,
        component: Editorial,
        exact: true,
    },
    {
        path: '/:collectionId',
        component: ProductList,
        exact: true,
    },
    // Optional subcategoryId token makes sure that perfumes PDP urls match
    // the ProductDetails route. Keep this before 3 tokens ProuctList route.
    {
        path: '/:collectionId/:categoryId/:subcategoryId?/:productSlug.html',
        component: ProductDetails,
        exact: true,
    },
    {
        path: '/:collectionId/:categoryId/:subcategoryId',
        component: ProductList,
        exact: true,
    },
    // ..._routes,
]

export default () => {
    const config = getConfig()
    return configureRoutes(routes, config, {
        ignoredRoutes: ['/callback', '*'],
    })
}
